export enum StudioFeatureFlags {
    DesignViewNUI = 'DesignView-NUI',
    FollowCreativeSet = 'Studio-FollowCreativeSet',
    ManageViewNUI = 'ManageView-NUI',
    StudioClientDAPIEnabled = 'StudioClient-DAPI-Enabled',
    StudioClientDAPIRendering = 'StudioClient-DAPI-Rendering',
    StudioEnableCropFeatures = 'Studio-EnableCropFeatures',
    StudioHideTPanel = 'Studio-HideTPanel',
    VideoBudgetEnabled = 'StudioApi_UseUserDefinedTargetWeights',
    VideoEditingEnabled = 'StudioClient-VideoEdit-Enabled'
}
